import { v4 as uuidv4 } from 'uuid';

export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: "@group",
    ControlProps: {
      Content: [],
    },
    HeaderProps: {
      title: "标题",
    },
  }
}
